<div class="contents">
  <div class="header">
    {{title}}
    <button mat-dialog-close class="close-btn" (click)="closeDialog(false)" matTooltip="{{'businessTexts.close' | translate}}">
      <cqes-icon icon="close" class="close-icon"></cqes-icon>
    </button>
  </div>

  <mat-card>
    <form *ngIf="identifierForm" [formGroup]="identifierForm">
      <div class="row" *ngIf="!searchHit">
        <div class="flex">
          <mat-form-field>
            <mat-label>{{'businessTexts.identifier' | translate}}</mat-label>
            <input matInput type="text" (keypress)="keyPressNumbers($event)" id="identifier" (keydown)="onKeyDown($event)"
              formControlName="identifier">
            <button *ngIf="checkInput()" mat-icon-button matSuffix matTooltip="{{'businessTexts.clear' | translate}}" (click)="clearInput()">
              <cqes-icon icon="close" class="close-icon-input"></cqes-icon>
            </button>
            <mat-error>
              {{'validationTexts.invalidData' | translate }}
            </mat-error>
          </mat-form-field>

          <button mat-icon-button [disabled]="!identifierForm.valid" matTooltip="{{'businessTexts.search' | translate}}"
            (click)="searchUser()" *ngIf="!editedUser && !loaded">
            <cqes-icon icon="search" class="search-icon" [ngClass]="{'disabled' :!identifierForm.valid}"></cqes-icon>
          </button>

        
        </div>
      </div>

      <div class="spinner-container" *ngIf="searchHit && !loaded" >
        <mat-spinner></mat-spinner>
      </div>
      
    </form>


    <form *ngIf="userForm && loaded" [formGroup]="userForm">
      <div class="row">
        <div class="col-6">
          <mat-form-field>
            <mat-label>{{'businessTexts.name' | translate}}</mat-label>
            <input matInput type="text" id="name" formControlName="name">
            <mat-error>
              {{'validationTexts.invalidData' | translate }}
            </mat-error>


          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field>
            <mat-label>{{'businessTexts.position' | translate}}</mat-label>
            <input matInput type="text" id="position" formControlName="position">
            <mat-error>
              {{'validationTexts.invalidData' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <!-- add -->
          <mat-form-field *ngIf="!isEdit">
            <mat-label>{{'businessTexts.email' | translate}}</mat-label>
            <mat-select formControlName="email">
              <mat-option *ngFor="let email of newUser.emails" [value]="email.email">
                {{email.email}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- edit -->
          <mat-form-field *ngIf="isEdit">
            <mat-label>{{'businessTexts.email' | translate}}</mat-label>
            <mat-select formControlName="email">
              <mat-option *ngFor="let email of editedUser.emails" [value]="email">
                {{email}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col">

          <!-- add -->
          <mat-form-field *ngIf="!isEdit">
            <mat-label>{{'businessTexts.phone' | translate}}</mat-label>
            <mat-select formControlName="phoneNumber">
              <mat-option *ngFor="let phone of newUser.phones" [value]="phone.number">
                {{phone.number}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- edit -->
          <mat-form-field *ngIf="isEdit">
            <mat-label>{{'businessTexts.phone' | translate}}</mat-label>
            <mat-select formControlName="phoneNumber">
              <mat-option *ngFor="let phone of editedUser.phoneNumbers" [value]="phone">
                {{phone}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <mat-form-field>
            <mat-label>{{'businessTexts.role' | translate}}</mat-label>
            <mat-select formControlName="role">
              <mat-option *ngFor="let role of roles" [value]="role">
                {{getRoleName(role)}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field>
            <mat-select placeholder="{{'businessTexts.groups' | translate}}" formControlName="groups" multiple [compareWith]="compareObjects">
              <mat-select-trigger>
                {{getTriggerMessage()}}
              </mat-select-trigger>
              <mat-option *ngFor="let group of allGroups" [value]="group"> {{getName(group)}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </form>

    <div class="button-container">
      <button mat-raised-button mat-dialog-close color="primary" (click)="closeDialog(false)">{{'businessTexts.cancel' |
        translate}}</button>
      <button mat-raised-button [disabled]="!userForm.valid || !userForm.dirty" color="primary"
        (click)="onSave()">{{getButtonLabel()}}</button>
    </div>
  </mat-card>
</div>